import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'
 

class Banner extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
         
        return ( 
               <Card> 
                   <Card.Body style={{padding: '0.5rem'}}>
                        <div id="carousel-interval" className="carousel slide" data-ride="carousel" data-interval={2000}>
                            <ol className="carousel-indicators">
                            {
                                this.props.array.map(
                                    (item, index) => (
                                        index > 0)?
                                            <li id={index} data-target="#carousel-interval" data-slide-to={index}></li>
                                            : <li id={index} data-target="#carousel-interval active" data-slide-to={index}></li>
                                    )
                            }
                            </ol>
                            <div className="carousel-inner" style={{maxHeight: '268px', height: 'auto', objectFit: 'cover'}} role="listbox">
                            {
                                this.props.array.map(
                                    (item, index) => (

                                        index > 0)?
                                                <div className="carousel-item ">
                                                    <img className="img-fluid" src={item.path} alt={index+" slide"} />
                                                </div> 
                                                : <div className="carousel-item active">
                                                    <img className="img-fluid" src={item.path} alt={index+" slide"} />
                                                </div> 
                                    )
                            }
                            </div>
                            <a className="carousel-control-prev" href="#carousel-interval" role="button" data-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true" />
                            <span className="sr-only">Previous</span>
                            </a>
                            <a className="carousel-control-next" href="#carousel-interval" role="button" data-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true" />
                            <span className="sr-only">Next</span>
                            </a>
                        </div>  
                   </Card.Body>
               </Card>
            );
        }
    }
    
    export default Banner;